export class GeneralApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    post(url, data, options, headers = {
        "Content-Type": "application/json",
    }) {
        return this.httpRequest.post(url, data, options, headers);
    }
}
